{
  "version": 1,
  "asset_id": "9d231ca9-511e-4586-8c4c-1952b12c016c",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/9d231ca9-511e-4586-8c4c-1952b12c016c/tools-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/9d231ca9-511e-4586-8c4c-1952b12c016c/tools-thumb.webp",
  "original_filename": "tools-thumb.webp",
  "size": 9586,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:31Z"
}
